import { UserRole } from '../types';

/**
 * Determina a página "home" baseada no role do usuário
 */
export const getHomeRoute = (userRole?: UserRole): string => {
  switch (userRole) {
    case 'SUPER_ADMIN':
      return '/dashboard';
    case 'ASSOCIACAO':
      return '/dashboard';
    case 'USUARIO_FINAL':
      return '/dashboard'; // Dashboard é o home principal para ver todas as opções
    default:
      return '/login';
  }
};

/**
 * Hook para navegação baseada no contexto do usuário
 */
export const getBackRoute = (userRole?: UserRole): string => {
  return getHomeRoute(userRole);
}; 